export const VALID = 'VALID'
export const INVALID = 'INVALID'
